import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

const NotFoundPage: React.FC = () => {
  const { isSignedIn } = useAuth();

  return (
    <div className="min-h-screen bg-white px-4 flex items-center justify-center">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <img
            className="mx-auto h-12 w-auto"
            src="/logo.png"
            alt="Ledgiventa"
          />
        </div>
        <div>
          <h1 className="text-9xl font-extrabold text-primary-600 tracking-widest">404</h1>
          <h2 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Page not found</h2>
          <p className="mt-6 text-base leading-7 text-gray-600">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <div className="mt-10 flex justify-center">
            {isSignedIn ? (
              <Link
                to="/dashboard"
                className="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                Return to dashboard
              </Link>
            ) : (
              <Link
                to="/"
                className="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                Go back home
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
